import { motion } from "framer-motion";

export const WhatIsCrossPlatformApp = () => {
  return (
    <section className="container">
      <div className=" space-y-14 bg-[#f3ebfa] px-5 md:px-10 lg:px-20 py-10 rounded-3xl">
        <div className="space-y-4">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px] text-center  font-bold text-dark font-butler"
          >
            What is a <span className="whitespace-nowrap">Cross-platform</span>{" "}
            App?{" "}
          </motion.h2>
          <div className="space-y-4">
            <p className="text-base leading-[1.625rem]">
              A cross-platform mobile app is a single application built to run
              on both iOS and Android operating systems using a shared codebase.
              Instead of writing separate native code for each platform,
              developers use frameworks that compile or bridge shared logic into
              native components. The app’s user interface is either rendered
              using mobile platform’s native widgets or compiled into native
              binaries, allowing it to access device features like the camera,
              GPS, and push notifications while maintaining near-native
              performance.
            </p>
          </div>
        </div>
        <div className="space-y-4">
          <motion.h3
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className="text-[25px] md:text-[30px] lg:text-[35px] xl:text-[40px] 2xl:text-[40px] !leading-[1.2]   text-center  font-bold text-dark font-butler"
          >
            What is Cross&#8209;Platform
             Mobile App Development?
          </motion.h3>
          <div className="space-y-4">
            <p className="text-base leading-[1.625rem]">
              Cross-platform mobile app development is the process of building
              mobile apps for both iOS and Android, using frameworks such as
              React Native or Flutter. This approach reduces development time,
              lowers costs, and enables synchronized updates across both
              platforms.
            </p>
            <p className="text-base leading-[1.625rem]">
              When looking to find companies that specialize in cross-platform
              mobile app development, it is critical to hire developers who
              understand the nuances of hardware-level abstraction and
              performance optimization.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
